
const FaPlusMinus = (props:{ className: string, isOpen: boolean }) => {
  return (
    <>
      {props.isOpen ? (
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true" className={`${props.className} oc se`}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6"></path></svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true" className={`${props.className} oc se`}><path strokeLinecap="round" strokeLinejoin="round" d="M18 12H6"></path></svg>
      )
      }
    </>
  )
}

export default FaPlusMinus